<template>

<div v-if="!hidden">

  <v-select
    solo-inverted
    flat
    :items="selectStages(stageIndex)"
    v-model="value.next"
    item-text="name"
    item-value="value"
    label="Stage"
    dense
    style="min-height: 95px; max-width: 150px;"
    :disabled="mode!='default'"
    />

  <next-child-box
    v-for="(child, childIndex) in step.if.children"
    :key="step"
    :parent="step"
    :value="child"
    :hidden="childHidden"
    :step="child"
    :stages="stages"
    :index="childIndex"
    :stageIndex="stageIndex"
    :mode="mode"
    class="mt-2" />

</div>

</template>


<script>

export default {

  name: 'nextChildBox',

  props: {
    value: {
      type: Object
    },
    step: {
      type: Object,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: Object,
    },
    index: {
      type: Number
    },
    stages: {
      type: Array
    },
    stageIndex: {
      type: Number
    },
    mode: {
      type: String,
      default: 'default'
    }
  },

  data() {

    return {
      childHidden: false
    }

  },
  computed:{
    hideElement(){
      return this.$store.getters.isCurrentConditionBoxHidden(this.step.if);
    }
  },
  created(){
    this.childHidden = this.hideElement;
  },
  watch:{
    hideElement:{
      handler(status){
        this.childHidden = status;
      }
    },
    hidden(status){
      this.childHidden = status;
    }
  },

  methods: {

    editAllocation(allocation) {
      this.$emit('editAllocation', allocation);
    },

    deleteAllocation(step, parent, index) {
      this.$emit('deleteAllocation', step, parent, index);
    },

    selectStages(currentStageIndex) {

      let stages = this.stages
        .map((s, index) => {
            return {
              name: s.name,
              value: index,
            }
        })
        .filter((s) => s.value != currentStageIndex);

      return [
        {
          name: 'END',
          value: null
        },
        ...stages
      ]

    },
  }

}


</script>


<style lang="scss">


</style>
